import React, { useEffect, useRef, useState } from "react";
import {
  Badge,
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import ListHeader from "components/Headers/ListHeader";
import axiosConfig from "consts/axiosConfig";
import Swal from "sweetalert2";
import { simpleWebRequest } from "consts/Constants";
import { states } from "consts/USSTATES";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import moment from "moment";
import FilterModal from "./FilterModal";
import { useDownloadExcel } from "react-export-table-to-excel";

export default function ReferInsReports(props) {
  const [loading, setLoading] = useState(false);
  const [items, setITems] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const tableRef = useRef(null);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "ReferIns",
    sheet: "ReferIns",
  });
  const getItems = () => {
    setFromDate(null);
    setToDate(null);
    setLoading(true);
    axiosConfig
      .get("user/reports/referins")
      .then((res) => {
        setLoading(false);
        setITems(res.data.result.referins);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const filterReports = () => {
    setShowModal(false);
    var from = moment(
      fromDate.year + "-" + fromDate.month + "-" + fromDate.day
    ).format("yyyy-MM-DD");
    var to = moment(toDate.year + "-" + toDate.month + "-" + toDate.day).format(
      "yyyy-MM-DD"
    );
    setLoading(true);
    axiosConfig
      .get(`user/reports/referins?start=${from}&end=${to}`)
      .then((res) => {
        setLoading(false);
        setITems(res.data.result.referins);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getItems();
  }, []);
  const renderItems = () => {
    if (loading) {
      return (
        <tr className="text-center">
          <td colSpan={7}>
            <Spinner color="info" size="xl" />
          </td>
        </tr>
      );
    } else if (items && items.length > 0) {
      return items.map((tr) => {
        return (
          <tr key={tr.id} className="text-center">
            <td>{tr.case.name}</td>
            <td>{tr.from.fullname ? tr.from.fullname : tr.from.name}</td>
            <td>{tr.client.fullname}</td>
            <td>{tr.notes}</td>
            <td>{tr.status}</td>
            <td>{moment(tr.created_at).format("yyyy-MM-DD HH:mm")}</td>
          </tr>
        );
      });
    } else {
      return (
        <tr className="text-center">
          <td colSpan={7}>
            <p>No Refer Ins yet!</p>
          </td>
        </tr>
      );
    }
  };
  return (
    <>
      <FilterModal
        showModal={showModal}
        toggleModal={setShowModal}
        fromDate={fromDate}
        setFromDate={setFromDate}
        toDate={toDate}
        setToDate={setToDate}
        filterReports={filterReports}
        title="Filter"
      />
      <ListHeader
        name="Refer Ins Report"
        parentName="Dashboard"
        setShowModal={setShowModal}
        btnName="Filter"
        setExtraButton={onDownload}
        extraBtnName="Export"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardHeader>
                <h3 className="mb-0">
                  Refer Ins{" "}
                  <span className="text-muted">
                    {fromDate && toDate
                      ? `from ${moment(
                          fromDate.year +
                            "-" +
                            fromDate.month +
                            "-" +
                            fromDate.day
                        ).format("yyyy-MM-DD")} 
                  to 
                  ${moment(
                    toDate.year + "-" + fromDate.month + "-" + fromDate.day
                  ).format("yyyy-MM-DD")}`
                      : ""}
                  </span>
                  {fromDate && toDate ? (
                    <Button color="link" size="sm" onClick={() => getItems()}>
                      Reset
                    </Button>
                  ) : (
                    <></>
                  )}
                </h3>
              </CardHeader>

              <table className="table table-striped" ref={tableRef}>
                <thead>
                  <tr>
                    <th>CASE NAME</th>
                    <th>FROM</th>
                    <th>CLIENT</th>
                    <th>REFERRAL NOTES</th>
                    <th>STATUS</th>
                    <th>DATE</th>
                  </tr>
                </thead>
                <tbody>{renderItems()}</tbody>
              </table>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}
